/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getPoolingReport } from '../fn/pooling/get-pooling-report';
import { GetPoolingReport$Params } from '../fn/pooling/get-pooling-report';
import { PoolingReportArrayResponse } from '../models/pooling-report-array-response';

@Injectable({ providedIn: 'root' })
export class PoolingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPoolingReport()` */
  static readonly GetPoolingReportPath = '/pooling/organization-sites/{organizationSiteKey}/report';

  /**
   * Get a report of all exchanged load-carriers in the given time-frame.
   *
   * Get an array of information about all exchanged load-carriers in the given time-frame (max. 2 days).
   * Only load-carriers that are mapped to the requesting organization-site are included in the report.
   * The time-frame must not exceed 2 days.
   * The report can optionally be filtered by consignor-site and by an exact load-carrier name (case-insensitive).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPoolingReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPoolingReport$Response(params: GetPoolingReport$Params, context?: HttpContext): Observable<StrictHttpResponse<PoolingReportArrayResponse>> {
    const obs = getPoolingReport(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a report of all exchanged load-carriers in the given time-frame.
   *
   * Get an array of information about all exchanged load-carriers in the given time-frame (max. 2 days).
   * Only load-carriers that are mapped to the requesting organization-site are included in the report.
   * The time-frame must not exceed 2 days.
   * The report can optionally be filtered by consignor-site and by an exact load-carrier name (case-insensitive).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPoolingReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPoolingReport(params: GetPoolingReport$Params, context?: HttpContext): Observable<PoolingReportArrayResponse> {
    const resp = this.getPoolingReport$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PoolingReportArrayResponse>): PoolingReportArrayResponse => r.body)
    );
  }

}
